var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46086 14.7824C4.16663 12.4882 4.16663 8.75506 6.46086 6.46083C8.7551 4.16659 12.4882 4.16659 14.7825 6.46114C17.0767 8.75506 17.0767 12.4882 14.7825 14.7824C12.4882 17.077 8.75541 17.077 6.46086 14.7824ZM20.9997 19.7665L20.5468 19.3135L16.5896 15.3567C18.9692 12.3647 18.7787 8.00025 16.011 5.23258C13.0346 2.25581 8.20877 2.25581 5.23231 5.23258C2.25585 8.20904 2.25585 13.0345 5.23262 16.011C7.99997 18.7787 12.3645 18.9692 15.3567 16.5896L19.3139 20.547L19.7668 21L20.9997 19.7665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/Zoom.d734b6aded550123eb5ec9671ce00fcd.svg";
export { ForwardRef as ReactComponent };